import {
    Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, Renderer2
} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {debounceTime, map, take, takeUntil} from 'rxjs/operators';
import {combineLatest, distinctUntilChanged, Observable, Subject} from 'rxjs';
import {FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {UrlParameter} from '@iw-shop/article/model/articles-list-handler';
import {GlobalState} from '@store/state/global.state';
import {MappedCustomer} from '@store/state/user.state';
import {getMappedCustomer, getSelectedBillingAddress, getSelectedCustomer} from '@store/selectors/user.selector';
import {logout} from '@store/actions/authentication.action';
import {resetDeliveryArea, deselectCustomer} from '@store/actions/storage.action';
import {MessageService} from 'primeng/api';
import {UserService} from '@iw-shop/user/services/user.service';
import {ConfigService} from "@iw-shop/config/service/config.service";
import {ApiArticlesGetAllowedValues} from "@api/articles";
import {EnvironmentService} from "@iw-shop/core/services/environment.service";
import {ConfigState} from "@store/state/config.state";
import {
    faCircleRight,
    faEdit,
    faEnvelope,
    faHeart,
    faHome, faLocationDot,
    faRightFromBracket,
    faSearch,
    faShoppingBag, faTruck,
    faUndoAlt,
    faUser
} from "@fortawesome/free-solid-svg-icons";
import {StorageState} from "@store/state/storage.state";
import {DeliveryTourService} from "@iw-shop/delivery-tour/services/delivery-tour.service";
import {isPlatformBrowser} from "@angular/common";
import {Customer} from "@iw-shop/customer/models/customer";
import {ApiFilter, ApiFilterDeprecated} from "@api/filter";

@Component({
    selector: 'layout-shop',
    standalone: false,
    templateUrl: './layout-shop.component.html',
    styleUrls: ['./layout-shop.component.scss'],
    providers: [MessageService]
})
export class LayoutShopComponent implements OnInit, OnDestroy {

    @Input() newsAvailable: boolean = false;
    @Input() newsUnreadCounter: number = 0;

    protected readonly isBrowser: boolean;

    destroy$: Subject<boolean> = new Subject<boolean>();


    customerId?: string;
    customer$: Observable<MappedCustomer | undefined>;

    selected$: Observable<GlobalState['selected'] | undefined>;
    userMappedCustomers$?: Observable<Customer[] | undefined>;

    global$: Observable<GlobalState | undefined>;
    config$: Observable<ConfigState | undefined>;
    storage$?: Observable<StorageState | null | undefined>;
    articlesInCart: number = 0;

    selectedGroup?: string;
    selectedGroup1?: string;

    showAccountMenu: boolean = false;
    showAccountMenuMobile: boolean = false;
    showMenuMobile: boolean = false;
    showModalLoginRegister: boolean = false;
    showRegisterComponent: boolean = false;

    modalLoginRegisterMessage?: string;

    myAccount: string = 'Mein Konto';
    notification: string | false = false;

    form = new FormGroup({
        'searchString': new FormControl('')
    });

    resourceUrl?: any = null;


    breadcrumb?: Observable<GlobalState['breadcrumb']>;

    constructor(
        private store: Store<AppState>,
        private route: ActivatedRoute,
        private environmentService: EnvironmentService,
        public deliveryTourService: DeliveryTourService,
        @Inject(PLATFORM_ID) platformId: Object,
        private userService: UserService,
        private router: Router,
        private configService: ConfigService) {

        this.isBrowser = isPlatformBrowser(platformId);

        this.breadcrumb = this.store.select(state => state.global.breadcrumb);
        this.customer$ = this.store.select(getSelectedCustomer);
        this.global$ = this.store.select(state => state.global);
        this.config$ = this.store.select(state => state.config);
        this.storage$ = this.store.select(state => state.storage);
        this.selected$ = this.store.select(state => state.global.selected);
        this.store.select(getSelectedCustomer).pipe(takeUntil(this.destroy$)).subscribe(r => {
            if (r) {
                this.customerId = r.id;
            }
        });
    }
    get isWithdrawalEnabled(): boolean {
        const cutoffDate = new Date('2026-06-19T00:00:00');
        return new Date() >= cutoffDate;
    }

    isAccess(type: 'invoices' | 'users' | 'favorites' | 'prices'): boolean {
        return this.userService.hasLoggedInUserAccess({type, customerId: this.customerId ?? ''});
    }

    ngOnInit() {
        this.resourceUrl = this.environmentService.environment.urlS3;
        this.userMappedCustomers$ = this.store.select(getMappedCustomer);

        /*    let p = this.route.snapshot.queryParamMap.get('p') ?? '';

            if (p.length > 0) {
                let searchString = JSON.parse(atob(p)).searchString;
                if (searchString && searchString.length > 0) {
                    this.form.get('searchString')?.setValue(JSON.parse(atob(p)).searchString);
                    this.form.get('searchStringMobile')?.setValue(JSON.parse(atob(p)).searchString);
                    if (this.route.snapshot.queryParamMap.get('mobile')) {
                        this.showMobileSearchInput = true;
                    }
                }
            }*/
        this.store.select(state => state.shoppingCart)
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe(
                res => {
                    if (res.count?.articles) {
                        this.articlesInCart = res.count.articles.items;
                    } else {
                        this.articlesInCart = 0;
                    }
                }
            );

        this.store.select(getSelectedBillingAddress)
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe(
                c => {
                    if (c) {
                        if (c.firstName && c.name) {
                            this.myAccount = c.firstName + ' ' + c.name;
                        } else if (c.gesoftName1) {
                            this.myAccount = c.gesoftName1;
                        } else {
                            this.myAccount = 'Mein Konto';
                        }
                    } else {
                        this.myAccount = 'Mein Konto';
                    }
                }
            );

        const urlParams: Observable<any> = combineLatest(
            [
                this.route.params,
                this.route.queryParams
            ]
        ).pipe(
            map(([params, queryParams]) => ({...params, ...queryParams}))
        );
        urlParams
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe(params => {
                let searchString = '';
                let p = undefined;
                if (params['p']) {
                    p = JSON.parse(atob(params['p']));
                }
                if (p?.searchString) {
                    searchString = p.searchString;
                }
                this.form.get('searchString')?.setValue(searchString);
                // Params
                if (params['action']) {
                    switch (params['action']) {
                        case 'loginRequired':
                            this.modalLoginRegisterMessage = 'Der Menüpunkt steht erst nach dem Login / Registrierung zur Verfügung.';
                            this.showModalLoginRegister = true;
                            break;
                    }

                }
            });

        this.form.get('searchString')?.valueChanges
            .pipe(
                takeUntil(this.destroy$),
                distinctUntilChanged(),
                debounceTime(500)
            )
            .subscribe(
                value => {
                    if (value !== '') {
                        let extras: NavigationExtras = {};
                        const urlParameter: UrlParameter = {
                            searchString: value ?? ''
                        };
                        extras.queryParams = {
                            p: btoa(JSON.stringify(urlParameter))
                        }
                        this.router.navigate(['/sortiment', 'list'], extras).then();
                    }
                }
            );
    }
    sanitizeUniqueName(name: string): string {
        // Replace all non-alphanumeric characters with a hyphen or an empty string
        return name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    }

    deselectCustomer() {
        this.store.dispatch(deselectCustomer());
    }

    setNotification(notification: string, timeout: number = 5) {
        this.notification = notification;
        if (timeout) {
            setTimeout(() => {
                this.notification = false;
            }, timeout * 1000);
        }
    }

    setSelectedGroup(group: string) {
        this.selectedGroup = group;
    }
    setSelectedGroup1(group: string) {
        this.selectedGroup1 = group;
    }

    navigateToGroup1(group: string, group1: string) {
        let extras: NavigationExtras = {};

        const filterGroup1: ApiFilter<ApiArticlesGetAllowedValues['filterFields']> = {field: 'groups.group1Name', value: group1};

        const urlParameter: UrlParameter = this.configService.getDefaultArticleListRequestParams();
        if (urlParameter.filters &&
            urlParameter.filters.length > 0) {
            urlParameter.filters.push(filterGroup1)
        } else {
            urlParameter.filters = [filterGroup1];
        }


        extras.queryParams = {
            p: btoa(JSON.stringify(urlParameter))
        };
        this.router.navigate(['/sortiment/', group], extras).then();
    }

    getDynamicPageLinks(linkPositions:  ['top' | 'b2b_foot' | 'foot_0' | 'foot_1' | 'foot_2']): GlobalState['dynamicPageLinks'] {
        let dynamicPageLinks: GlobalState['dynamicPageLinks'] = [];
        this.store.select(state => state.global.dynamicPageLinks)
            .pipe(take(1))
            .subscribe(
                dp => {
                    dynamicPageLinks = dp ?.filter(r => {
                        return r.linkPositions.some(x => linkPositions.includes(x));
                    });
                }
            );

        return dynamicPageLinks;
    }

    setHello() {
        this.store.select(getSelectedBillingAddress)
            .pipe(
                take(2)
            )
            .subscribe(
                c => {
                    if (c) {
                        this.setNotification('Hallo ' + c.gesoftName1);
                    }
                }
            );
    }

    setLoginSuccess() {
        this.showModalLoginRegister = false;
        let redirectTo = this.route.snapshot.queryParamMap.get('redirectTo') ?? '';
        if (redirectTo.length > 0) {
            this.router.navigate([redirectTo]).then();
        }
    }

    setRegisterSuccess() {
        this.store.select(getSelectedBillingAddress)
            .pipe(
                take(2)
            )
            .subscribe(
                c => {
                    if (c) {
                        this.setNotification('Registrierung erfolgreich. <br> Herzlich Willkommen ' + c.salutation + ' ' + c.firstName + ' ' + c.name + '!');
                    }
                }
            );
    }

    setLogout() {
        this.store.dispatch(logout());
        this.store.select(state => state.storage.userId)
            .pipe(
                take(2),
                distinctUntilChanged()
            )
            .subscribe(
                r => {
                    if (!r) {
                        this.setNotification('Abmeldung erfolgreich');
                    }

                }
            );
    }

    toggleMenuMobile() {
        this.showMenuMobile = !this.showMenuMobile;
    }

    toggleLoginRegister() {
        this.showModalLoginRegister = !this.showModalLoginRegister;
        if (!this.showModalLoginRegister) {
            this.modalLoginRegisterMessage = undefined;
            this.showRegisterComponent = false;
            this.router.navigate([], {queryParams: {}, relativeTo: this.route}).then();
        }
    }

    resetSearch() {
        this.form.get('searchString')?.setValue('');
    }

    resetDeliveryArea() {
        this.store.dispatch(resetDeliveryArea());
    }

    isWebdrinkUrl(){
        if(this.isBrowser){
            const parsedUrl = new URL(window.location.href);
            // Check if the hostname ends with the provided domain
            return parsedUrl.hostname.endsWith('webdrink.de');
        }
        return false;
    }


    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    protected readonly faRightFromBracket = faRightFromBracket;
    protected readonly faSearch = faSearch;
    protected readonly faEnvelope = faEnvelope;
    protected readonly faUser = faUser;
    protected readonly faHeart = faHeart;
    protected readonly faShoppingBag = faShoppingBag;
    protected readonly faHome = faHome;
    protected readonly faEdit = faEdit;
    protected readonly faLocationDot = faLocationDot;
    protected readonly faCircleRight = faCircleRight;
    protected readonly faTruck = faTruck;
    protected readonly encodeURIComponent = encodeURIComponent;
    protected readonly faUndo = faUndoAlt;
}
